/**
 * Cap a plain string at `max` chars on a word boundary plus ellipsis.
 * No-op when the string is already short enough.
 */
export function truncate(input: string, max: number): string {
  if (!input || input.length <= max) return input ?? '';
  const slice = input.slice(0, max);
  const lastSpace = slice.lastIndexOf(' ');
  const cut = lastSpace > max * 0.6 ? slice.slice(0, lastSpace) : slice;
  return cut.replace(/[\s.,;:!?-]+$/, '') + '…';
}

export { stripMarkdownToLine } from '@/utils/display-text';
